import { Alert as ThemeUIAlert } from 'theme-ui';

const Alert = (props) => (
  <ThemeUIAlert mb={4} role="alert" {...props}>
    {props.children}
  </ThemeUIAlert>
);

export default Alert;
